import { Flex, Box } from "@twilio-paste/core";
import { useDispatch, useSelector } from "react-redux";
import { setDestinationNumber } from "../../actions";

const containerStyle = {
  background: "linear-gradient(135deg, rgba(240, 247, 255, 0.8) 0%, rgba(225, 238, 255, 0.5) 100%)",
  borderRadius: "18px",
  border: "1px solid rgba(2, 99, 224, 0.08)",
  padding: "20px 16px 14px",
  backdropFilter: "blur(6px)",
  WebkitBackdropFilter: "blur(6px)",
};

const inputStyles = {
  backgroundColor: "transparent",
  width: "100%",
  textAlign: "center",
  fontSize: "2.6rem",
  fontWeight: "300",
  outline: "none",
  border: "none",
  color: "rgb(20, 28, 45)",
  letterSpacing: "0.04em",
  caretColor: "rgb(2, 99, 224)",
  fontFamily: "inherit",
};

const labelStyle = {
  fontSize: "0.7rem",
  fontWeight: "500",
  color: "rgba(2, 99, 224, 0.5)",
  letterSpacing: "0.12em",
  textTransform: "uppercase",
  textAlign: "center",
  marginTop: "8px",
  display: "block",
};

export default function PhoneNumberInput() {
  const dispatch = useDispatch();
  const destinationNumber = useSelector((state) => state.destinationNumber);

  return (
    <Box backgroundColor={"colorBackgroundBody"}>
      <Flex
        height={"size20"}
        vertical
        hAlignContent={"center"}
        vAlignContent={"bottom"}
        padding={"space60"}
      >
        <div style={containerStyle}>
          <input
            type="text"
            id="destinationNumber"
            placeholder="+1 (971) 459-8531"
            value={destinationNumber}
            style={inputStyles}
            onChange={(e) => {
              dispatch(setDestinationNumber(e.target.value));
            }}
          />
          <label htmlFor="destinationNumber" style={labelStyle}>
            Destination Number
          </label>
        </div>
      </Flex>
    </Box>
  );
}
